import React from "react";

const LegislationStatsCard = () => {
    const stats = [
        {
            label: "Total Resolutions",
            value: 80,
            bgColor: "bg-blue-50",
            textColor: "text-blue-600",
            description: "Number of Created Resolutions",
        },
        {
            label: "Total Ordinances",
            value: 5,
            bgColor: "bg-orange-50",
            textColor: "text-orange-600",
            description: "Total Enacted and Proposed Ordinances",
        },
        {
            label: "Active Legislations",
            value: 10,
            bgColor: "bg-green-50",
            textColor: "text-green-600",
            description: "Number of Active and Scheduled Consultations",
        },
        {
            label: "Archived Legislations",
            value: 10,
            bgColor: "bg-purple-50",
            textColor: "text-purple-600",
            description: "Count of Archived Legislative Records",
        },
    ];

    return (
        <div className="bg-white rounded-lg shadow-md p-6 mb-8 animate-in slide-in-from-bottom duration-700 delay-200">
            <div className="mb-6">
                <h2 className="text-2xl font-bold text-gray-900">Legislation</h2>
                <p className="text-gray-600 mt-1">Regulatory Framework & Legislative Status</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {stats.map((stat) => (
                    <div
                        key={stat.label}
                        className={`${stat.bgColor} rounded-lg p-4 hover:shadow-md transition-all duration-300 hover:-translate-y-1 cursor-pointer group border border-transparent hover:border-gray-200`}
                    >
                        <div className="flex items-start">
                            <div
                                className={`flex-shrink-0 flex items-center justify-center w-12 h-12 ${stat.textColor} ${stat.bgColor.replace('50', '100')} text-2xl font-bold rounded-lg group-hover:scale-105 transition-transform duration-200 border border-white`}
                            >
                                {stat.value.toLocaleString()}
                            </div>

                            <div className="ml-3 flex-1 min-w-0">
                                <p className="text-sm font-medium text-gray-600 truncate mb-1">
                                    {stat.label}
                                </p>

                                <p className="text-xs text-gray-500 break-words whitespace-normal leading-relaxed">
                                    {stat.description}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LegislationStatsCard;